export const STORE_TYPES = {
  COMPANY: 'companyStore',
  FRANCHISE: 'franchiseStore'
}